<template>
    <div style="width:100%;heigh:100%;" id="chechConf" class="quality-conf">
        <template v-if="showPage == 0">
            <div class="table_searchbar">
                <el-row :gutter="20">
                    <el-col :span="span">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">激活码：</span>
                            <el-input size="small" style="max-width:180px" v-model="searchForm.activationCode" maxlength="16" placeholder="激活码"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="24-2*span">
                        <div style="text-align:right">
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                            <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="table_common_operbar">
                <el-row>
                    <el-button v-if="permission.btn_qcTemp_add" icon="el-icon-plus" type="primary" size="small"   @click="addWindowShow()">新增激活码</el-button>
                </el-row>
            </div>
            <el-table :data="tableData" stripe style="width: 100%" class="deviceTable y_Public_table">
                <el-table-column prop="activationCode" label="激活码" min-width="100"></el-table-column>
                <el-table-column prop="isUse" label="使用状态" :formatter='parseType' min-width="100"></el-table-column>
                <el-table-column prop="gmtModified" label="操作时间" :formatter='parseDate' min-width="100"></el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" :formatter='parseModifiedDate' min-width="100"></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="100">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" @click="showViewDialog(scope.row)" size="small">查看</el-button> -->
                        <el-button type="text" @click="showEditDialog(scope.row)" v-if="permission.btn_qcTemp_update"  size="small">编辑</el-button>
                        <el-button type="text" @click="deleteConfig(scope.row)" v-if="permission.btn_qcTemp_delete"  size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page" v-if="tableData.length > 0">
                <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                    <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"> </el-pagination>
                </div>
            </div>

            <!-- 新增激活码开始-->
            <el-dialog title="新增激活码" @close="cancelAddDialog" :visible.sync="addDialogVisible" :width="span==5?'26%':'40%'" center :close-on-click-modal="false">
                <el-form :label-position="labelPosition" label-width="120px" :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                    <el-form-item prop="activationCode" label="激活码：" :rules="rules.templateName">
                        <el-input size="small" style="max-width:200px" v-model.trim="addForm.activationCode"  maxlength="16" placeholder="请输入激活码"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitAddDialog">确 定</el-button>
                    <el-button @click="cancelAddDialog">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 新增激活码结束 -->

            <!-- 编辑激活码开始 -->
            <el-dialog title="编辑激活码" @close="cancelEditDialog" :visible.sync="editDialogVisible"   :width="span==5?'26%':'40%'" center :close-on-click-modal="false">
                <el-form :label-position="labelPosition" label-width="120px" :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form">
                    <el-form-item prop="activationCode" label="激活码：" :rules="rules.templateName">
                        <el-input size="small" style="max-width:200px" v-model.trim="addForm.activationCode" maxlength="16" placeholder="请输入激活码"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitEditDialog">保 存</el-button>
                    <el-button @click="cancelEditDialog">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 编辑激活码结束 -->
        </template>
        <template v-if="showPage == 1">
            <ErrConf style="width:100%;heigh:100%;"></ErrConf>
        </template>
    </div>

</template>

<script>

    export default {
        name: 'activationList',
        components: {
            
        },
        data() {
            return {
                value1:'',
                TmouserShow: null,
                fristLoad: false,
                showPage: 0,
                labelPosition: 'right',
                workerList: [],
                deviceType: [],
                W: false,
                btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
                searchFormTemp: '',//临时搜索数据
                searchForm: {
                    activationCode: '',
                },
                addForm: {
                    activationCode: ''
                },
                viewForm: {},
                tableData: [],
                tableCurrentPage: 1,
                tableCurrentPage1: 1,
                tableTotalPage: 2,
                addDialogVisible: false,
                editDialogVisible: false,
                viewDialogVisible: false,
                data: {
                    token: localStorage.getItem("token"),
                },
                rules: {
                    activationCode: [
                        {required: true, message: '请输入激活码', trigger: 'blur'}
                    ],
                },
                permission: JSON.parse(localStorage.getItem("permission"))
            }
        },
        mounted: function () {
            this.initTable();
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
            window.onresize = () => {
                let w = document.documentElement.clientWidth || document.body.clientWidth;
                w >= 1900 ? this.W = true : this.W = false
            }
        },
        computed: {
            span() {
                return this.W ? 5 : 7
            }
        },
        deactivated: function () {
            console.log("deactivated");
        },
        methods: {
            parseType(e){
                return e.isUse == 1 ? "已使用":"未使用"
            },
            showConfigDialog() {
                this.showPage = 1
            },
            parseRatio(rowData) {
                if (rowData.ratio > 0) {
                    return rowData.ratio.toFixed() + '%'
                } else {
                    return rowData.ratio
                }
            },
            deleteConfig(rowData) {
                this.$confirm('此操作将删除该激活码, 删除后不可撤销，是否继续?', '提示', {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$RequestUtil.get({
                        url: '/api/activation/deleteActivationCode',
                        type: 'sync',
                        params: {
                            id: rowData.id
                        },
                        success: (res) => {
                            if (res.code != -1) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.search(1);
                                this.$store.commit("add_reloadPages", ['/Technology', '/TechnologyConfig']);
                            } else {
                                this.$message.error(res.msg || res.message)
                            }
                        }
                    })
                })
            },
            cancelEditDialog() {
                this.$refs['editForm'].resetFields()
                this.editDialogVisible = false
                this.addForm = {
                    activationCode: '',
                }
            },
            removeDetail(rowIndex) {
                this.addForm.qcItemTemplateList.splice(rowIndex, 1);
            },
            addqcItemTemplateList() {
                let json = {}
                json.id = null
                this.addForm.qcItemTemplateList.push(json)
            },
            cancelAddDialog() {
                this.$refs['addForm'].resetFields()
                this.addDialogVisible = false
                this.addForm = {
                    activationCode: '',
                }
            },
            submitAddDialog() {
                this.$refs['addForm'].validate((valid) => {
                    if (valid) {
                        this.$RequestUtil.post({
                            url: '/api/activation/addActivationCode',
                            type: 'sync',
                            params: this.addForm,
                            success: (res) => {
                                if (res.code == 0) {
                                    this.$message.success('添加成功')
                                    this.cancelAddDialog()
                                    this.initTable();
                                } else {
                                    this.$message.error(res.msg);
                                }
                            },
                        })

                    }
                    log(this.addForm)
                })
            },
            submitEditDialog() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        this.$RequestUtil.post({
                            url: '/api/activation/updateActivationCode',
                            type: 'sync',
                            params: this.addForm,
                            success: (res) => {
                                if (res.code == 0) {
                                    this.$message.success('编辑成功')
                                    this.cancelEditDialog()
                                    this.initTable();
                                } else {
                                    this.$message.error(res.msg);
                                }
                            },
                        })
                    }
                })
            },
            btnSearch: function () {
                this.tableCurrentPage = 1;
                this.btnPressType = 1
                this.search();
            },
            clearSearch() {
                let form = this.searchForm;
                this.btnPressType = 2;
                form.activationCode = '';
            },
            clearSearch1() {
                let form = this.errSearch;
                form.value = '';
            },
            search: function () {
                let temp;
                switch (this.btnPressType) {
                    case 1:
                        temp = commonUtils.cloneObj(this.searchForm);
                        this.searchFormTemp = commonUtils.cloneObj(temp);
                        break;
                    case 0:
                        temp = {
                            name: '',
                            reportTypeValue: '',
                        };
                        break;
                    case 2:
                        temp = this.searchFormTemp;
                        break;
                    case 3:
                        temp = this.searchFormTemp;
                        break;
                }
                this.$RequestUtil.get({
                    url: '/api/activation/listActivationCode',
                    type: 'sync',
                    params: {
                        pageNum: this.tableCurrentPage,
                        pageSize: 10,
                        activationCode: temp.activationCode
                    },
                    success: (res) => {
                        if (res.msg == this.$Global.RESPONSE.SUCCESS) {
                            this.tableData = res.data;
                            this.tableTotalPage = res.totalPages;
                            if (res.totalPages == 0 && this.fristLoad) {
                                this.$message.warning('查询不到符合条件的数据');
                            }
                            this.fristLoad = true
                        } else {
                            this.$message.error(res.msg || res.message)
                        }

                    }
                });
            },
            pageChange: function (targetPage) {
                this.tableCurrentPage = targetPage;
                this.btnPressType = 3;
                this.search();
            },
            pageChange1: function (targetPage) {
                this.tableCurrentPage1 = targetPage;
                this.loadErrList()
            },
            initTable: function () {
                this.search();
            },
            addWindowShow: function () {
                this.addDialogVisible = true;
                setTimeout(() => {
                    //this.$refs.focusinput.focus()
                }, 0)
            },
            showEditDialog: function (rowData) {
                this.editDialogVisible = true;
                this.addForm.id = rowData.id;
                this.$set(this.addForm, 'id', rowData.id);
                this.$set(this.addForm, 'activationCode', rowData.activationCode);
            },
            showViewDialog(rowData) {
                this.viewDialogVisible = true;
                this.addForm.templateName = rowData.templateName
                this.addForm.qcItemTemplateList = rowData.qcItemTemplateList
                this.addForm.qcTypePase = this.parseQcType(rowData)
                this.addForm.workerName = rowData.workerName
                this.addForm.ratioparse = this.parseRatio(rowData)
            },
            viewDevice: function (rowData) {
                this.viewDialogVisible = true;
            },
            parseDate: function (rowData) {
                if (rowData.gmtCreate != null) {
                    let dateString = commonUtils.timestampToDate(rowData.gmtCreate, true);
                    return dateString;
                }
            },
            parseModifiedDate(rowData) {
                if (rowData.gmtModified != null) {
                    let dateString = commonUtils.timestampToDate(rowData.gmtModified, true);
                    return dateString;
                }
            },
        }
    }
</script>

<style scoped>
    .delete {
        width: 18px;
        height: 19px;
        background-image: url('../../../static/img/del.png');
        cursor: pointer;
        background-repeat: no-repeat;
    }

    .delete:hover {

        background-image: url('../../../static/img/del-hover.png');
        background-repeat: no-repeat;
    }

    .table_searchbar .title11 {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
    }

    .add_form .title {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
        display: inline-block;
        text-align: right;
        width: 70px;
    }

    .add_form .value {
        display: inline-block
    }

    .el-row {
        margin-bottom: 20px;

    &
    :last-child {
        margin-bottom: 0;
    }

    }

    .table_searchbar {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .import_upload {
        display: inline;
    }

    .page {
        display: flex;
        justify-content: flex-end;
    }

    @media screen and (max-width: 1380px) {
        .page {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 30px;
        }
    }

    @media screen and (max-width: 1280px) {
        .quality-conf .value {
            width: 130px;
        }
    }

    .total_page {
        margin-top: 20px;
        margin-right: 26px;
        color: #606266;
        font-size: 14px;
    }
</style>
<style>
    #chechConf .el-form-item--mini.el-form-item, #chechConf .el-form-item--small.el-form-item {
        margin-top: 8px;
        margin-bottom: 13px;
    }

    .table_searchbar .el-button--mini, .el-button--mini.is-round {
        padding: 7px 10px;
    }

    .el-textarea .el-input__count {
        line-height: 12px;
    }
    #chechConf .el-table th:nth-child(1) .cell{
        padding-left:14px;
        padding-right: 14px;
    }
</style>




// WEBPACK FOOTER //
// src/views/activation/activationList.vue